import { api } from '../../utils';
import { Map } from 'immutable';
import actions from '@synergycms_app/store/actions';

export default {
  NAME: {
    GET: name => (name)
  },
  OUTER_WEB: {
    GET: val => (val)
  },
  CONFIG: {
    GET: val => (val),
    GET_HOTEL : (hotel, val) => ({[hotel]: val}),
    GET_ASYNC : (app, config) => (dispatch, getState) => {
      const store = getState();
      // return empty promise if currencies are already loaded
      if (!store.get("group") || store.getIn(['app', 'config']) ) {
        return Promise.resolve();
      }
      const deviceType = store.getIn(['system', 'device'])
      let device = (deviceType !== 'desktop') ? `,device:${deviceType}` : '';
      const url = `,url:${window.location.pathname}`;

      let query = {
        q: `app:${app},group:${store.get("group")}${device}${url}`,
      }
      if(app !== 'cms-engine'){
        return (!config ?
          api.get('frontend/config', query) :
          Promise.resolve(config)).then((result) => {;
            return Map(result);
        });
      }


      const requiredFields = ['i18n', 'lang_info', 'avail_url', 'hotels_info'];
      const missingFields = [];

      requiredFields.forEach(field => {
        if (!config.hasOwnProperty(field)) {
          missingFields.push(field);
        }
      });

      //se ha pasado config y resto de campos y se ignora la configuracion en Synergy
      if (missingFields.length === 0 && !!config.config?.ignore_synergy_config) {
        return Promise.resolve(config).then((result) => {
          dispatch(actions.customer.langInfo.get(result.lang_info))
          dispatch(actions.hotels.info.get(result.hotels_info))
          return Map(result.config);
        });
      }
      //En caso contrario (faltan campos o config no tiene ignore_synergy_config)
      if(config.config?.ignore_synergy_config){
        query.i = missingFields.join(',');
      }else{
        query.i = requiredFields.join(',');
      }
      return api.get('frontend/config/engine', query).then((result) => {
        //a pesar de tener config, se quiere recuperar la definida en bd
        if(!result.config?.ignore_synergy_config){
          if(result.config){
            if(!result.config?.links) {
              result.config.links = {}
              result.config.links.promoCode = null
            }
            if(!result.config?.theme_values) result.config.theme_values = {}
            if(!result.config?.theme) result.config.theme = {}
            result.config.avail_url = result.avail_url
            result.config.i18n = result.i18n
          }
          dispatch(actions.customer.langInfo.get(result.lang_info))
          dispatch(actions.hotels.info.get(result.hotels_info))

          return Map(result.config);
        }

        //si no hay config o no se tienen definidos los campos (engine_active, prices_active...)
        if(config.config){
          if(!('engine_active' in config.config)) config.config.engine_active = result.config?.engine_active;
          if(!('prices_active' in config.config)) config.config.prices_active = result.config?.prices_active;
          if(!config.avail_url) config.config.avail_url = result.avail_url;
          if(!config.i18n && result.i18n) config.config.i18n = result.i18n;
        }else{
          config = {
            ...config,
            config:{
              engine_active : result.config?.engine_active,
              prices_active : result.config?.prices_active,
              avail_url : result.avail_url,
              i18n : result.i18n,
            }
          }
        }
        dispatch(actions.customer.langInfo.get(config.lang_info ? config.lang_info : result.lang_info))
        dispatch(actions.hotels.info.get(config.hotels_info ? config.hotels_info : result.hotels_info))


        return Map(config.config)
      });
    },
    GET_HOTEL_ASYNC : (app, hotel, config) => (dispatch, getState) => {
      const store = getState();
      // return empty promise if currencies are already loaded

      if ( !hotel || store.getIn(['app', 'hotelConfig', hotel] )) {
        return Promise.resolve();
      }

      const deviceType = store.getIn(['system', 'device'])
      let device = (deviceType !== 'desktop') ? `,device:${deviceType}` : '';
      const url = `,url:${window.location.pathname}`;

      let query = {
        q: `app:${app},hotel:${hotel}${device}${url}`,
      }

      if(app !== 'cms-engine'){
        return (!config ?
          api.get('frontend/config', query) :
          Promise.resolve(config)).then((result) => {;
            return { [hotel] : result };
        });
      }

      const requiredFields = ['i18n', 'lang_info', 'avail_url'];
      const missingFields = [];
        requiredFields.forEach(field => {
          if (!config.hasOwnProperty(field)) {
            missingFields.push(field);
          }
        });
        //se ha pasado config y resto de campos y se ignora la configuracion en Synergy
        if (missingFields.length === 0 && !!config.config?.ignore_synergy_config) {
          return Promise.resolve(config).then((result) => {
            dispatch(actions.customer.langInfo.get(result.lang_info));
            return { [hotel] : result.config  };
          });
        }

        //En caso contrario (faltan campos o config no tiene ignore_synergy_config)
        if(config.config?.ignore_synergy_config){
          query.i = missingFields.join(',');
        }else{
          query.i = requiredFields.join(',');
        }

        return api.get('frontend/config/engine', query).then((result) => {
          if(!result.config?.ignore_synergy_config){
            if(result.config ) {
              if(!result.config?.links) result.config.links = {}
              if(!result.config?.theme_values) result.config.theme_values = {}
              if(!result.config?.theme) result.config.theme = {}
              result.config.avail_url = result.avail_url
              result.config.i18n = result.i18n
              result.config.group = result.group
            }
            dispatch(actions.customer.langInfo.get(result.lang_info))

            return { [hotel] : result.config };
          }

          if(result['cms-login']){
            config['cms-login'] = result['cms-login']
          }


          //si no hay config o no se tienen definidos los campos (engine_active, prices_active...)
          if(config.config){
            if(!('engine_active' in config.config)) config.config.engine_active = result.config?.engine_active;
            if(!('prices_active' in config.config)) config.config.prices_active = result.config?.prices_active;
            if(!config.config.currency_code && result.config?.currency_code) config.config.currency_code = result.config.currency_code;
            if(!config.group) config.config.group = result?.group;
            if(!config.avail_url) config.config.avail_url = result.avail_url;
            if(!config.i18n && result.i18n) {config.config.i18n = result.i18n; }
          }else{
            config = {
              ...config,
              config:{
                engine_active : result.config?.engine_active,
                prices_active : result.config?.prices_active,
                group : result?.group,
                avail_url : result.avail_url,
                i18n : result.i18n,
              }
            }
            if(result.config?.currency_code) config.config.currency_code = result.config.currency_code;
          }

          dispatch(actions.customer.langInfo.get(config.lang_info ? config.lang_info : result.lang_info))

          let resultMap = {
            [hotel] : config.config
          };

          if (config['cms-login']) {
            return set(lensPath([hotel,"cms-login"]), config['cms-login'], resultMap);
          }

          return resultMap;

        });
    },
  }
};
